export default __webpack_public_path__ + "static/media/List-documentation.64a4c24b.md";